import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
  IntegrationType,
} from 'models/InternalIntegrationSetting';

const useShouldRedirectToIntegrationsList = (id: IntegrationEnum) => {
  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: id,
    });

  const status = integrationAgencySettings?.agencySettings?.status;
  const isStatusBlocked =
    !isLoading &&
    !!status &&
    [IntegrationStatus.INACTIVE, IntegrationStatus.NOT_SUPPORTED].includes(
      status,
    );

  const isChannelIntegration =
    !isLoading &&
    integrationAgencySettings?.integration?.type === IntegrationType.CHANNEL;

  const isAllowedOnlyForAgencyLevel =
    !isLoading && integrationAgencySettings?.integration?.allowedForAgencyOnly;

  return isStatusBlocked || isChannelIntegration || isAllowedOnlyForAgencyLevel;
};

export default useShouldRedirectToIntegrationsList;
